/**
 * SheetLeaveModalComponent is a class that initializes and manages messages for a modal component.
 * It processes messages and groups them based on certain criteria.
 */
class SheetLeaveModalComponent {
    /**
     * Constructor for SheetLeaveModalComponent.
     * @param {Object} $scope - The AngularJS scope.
     * @param {Object} $uibModalInstance - The instance of the modal.
     * @param {Object} messages - The messages to be processed.
     */
    constructor($scope, $uibModalInstance, messages) {
        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;
        this.messages = messages;

        // Initialize the default structure for messages in the scope.
        this.$scope.messages = {
            'default_group': {
                'messages': {}
            }
        };

        this.init();
    }

    /**
     * Initializes the messages by processing and grouping them.
     */
    init() {
        for (let key in this.messages) {
            let message = this.messages[key];
            // Skip messages that do not have errors.
            if (message.error === false) continue;

            for (let sub_key in message.messages) {
                let sub_message = message.messages[sub_key];
                if (sub_message.group) {
                    // Ensure the group exists in the scope messages.
                    if (!this.$scope.messages[sub_message.group]) {
                        this.$scope.messages[sub_message.group] = {
                            'messages': {}
                        };
                    }
                    // Check for duplicate removal condition and add message.
                    if ((sub_message.remove_duplicate === true && Object.keys(this.$scope.messages[sub_message.group]['messages']).length === 0) || !sub_message.remove_duplicate) {
                        if (sub_message.message_key) {
                            this.$scope.messages[sub_message.group]['messages'][sub_message.message_key] = sub_message;
                        } else {
                            this.$scope.messages[sub_message.group]['messages'][this.createUUID()] = sub_message;
                        }
                    }
                } else {
                    // Add message to the default group if no specific group is specified.
                    if (sub_message.message_key) {
                        this.$scope.messages['default_group']['messages'][sub_message.message_key] = sub_message;
                    } else {
                        this.$scope.messages['default_group']['messages'][this.createUUID()] = sub_message;
                    }
                }
            }
        }
    }

    /**
     * Generates a UUID for messages that do not have a specific key.
     * @returns {string} A UUID.
     */
    createUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}

export default SheetLeaveModalComponent;